import { QueryClient } from '@tanstack/react-query';

import { isApiServiceError } from '@/services/http/errors';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            // cacheTime: 10 * 60 * 1000, // 10 minutes
            retry: (failureCount, error) => {
                if (isApiServiceError(error)) {
                    // Retrying a provider throttle immediately multiplies load and extends the
                    // throttle window. A later explicit refetch can safely try again.
                    if (error.code === 'RATE_LIMITED' || !error.isRetryable) {
                        return false;
                    }
                }

                return failureCount < 3;
            },
            refetchOnWindowFocus: false,
            refetchOnReconnect: 'always',
        },
        mutations: {
            retry: (failureCount, error) => {
                if (isApiServiceError(error) && !error.isRetryable) {
                    return false;
                }

                return failureCount < 1;
            },
        },
    },
});
